import {
  failExternalAuthRoundtrip,
  failLoginTiming,
  startExternalAuthRoundtrip,
  startLoginTiming,
  type LoginTimingContext,
} from "./loginTiming";

type MaybePromise<T> = T | Promise<T>;

function isPromiseLike<T>(value: MaybePromise<T>): value is Promise<T> {
  return Boolean(
    value && typeof value === "object" && "then" in value && typeof value.then === "function",
  );
}

export function startLoginRedirect<T>(
  context: LoginTimingContext,
  initiateLogin: () => MaybePromise<T>,
): MaybePromise<T> {
  try {
    startLoginTiming(context);
    // This is intentionally the last telemetry operation before keycloak.login().
    startExternalAuthRoundtrip();
  } catch {
    // Login must continue if telemetry or storage is unavailable.
  }

  try {
    const result = initiateLogin();

    if (isPromiseLike(result)) {
      result.catch((error) => {
        failExternalAuthRoundtrip(error);
        failLoginTiming(error, context);
      });
    }

    return result;
  } catch (error) {
    failExternalAuthRoundtrip(error);
    failLoginTiming(error, context);
    throw error;
  }
}
